import {doc} from '../docs.js';
import ZEnvelope from '../../custom/ZEnvelope.js';

doc(
    "envelope",
    {},
    "Creates a new envelope that can control parameters",
    () => 0,
    {
        inlets: 0
    }
);

export const envelope = (object) => {
    let env = new ZEnvelope(object);
    object.attributes["primary-color"] = "#cb3737";
    object.attributes["secondary-color"] = "#1c1c1c";
    return () => 0;
};

export const envelopeIndex = {
    envelope
};
